import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './Header/Header.jsx';
import Footer from './Footer.jsx';
import Login from './Login.jsx';
import WorkSpace from './workSpace/workSpace.jsx';
import Consulting from './workSpace/floatingWindows/Consulting.jsx';
import { messageFromSupervisor, agentUnavailableOnTransfer } from '../redux/actions/A_actions_from_SM';
import { changeState } from '../redux/actions/A_user_states';
import { noAvailableData } from '../redux/actions/A_no_available';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { validatingState } from '../redux/actions/A_validating_telephony';
import { newAssistedTransferState } from '../redux/actions/A_assisted_transfer';
import { insertWindow, removeWindow } from '../redux/actions/A_draggable_windows_controller';
import { USER_STATE, USER_ACTIONS, ACTION_CALL_ACD, API_ENDPOINTS, SOFTPHONES_KEY, SOFTPHONES_DEFAULT, STR_SOFTPHONE, SM_QUEUE_SERVER, HANG_UP_SUBACTIONS, DRAGGABLE_WINDOWS } from '../constants.js';
import { AgentControllerFactory } from 'cw-galatea-agent-controller-js/cw-galatea-agent-controller-js-bundle.min.js';
import { messageLogin, messageApiRequest, messageHangUp, RequestedLogout, Reconnected } from '../js/helpers/helperMessages';
import { SingletonSharedData } from '../js/singletonSharedData';
import SingletonWebSocket from '../js/Singletons/SingletonWebSocket';
import { STRATEGIES_STATES } from '../js/Strategies/StrategiesStates';
import { STRATEGIES_REDUCER_INTEGRATION } from '../js/Strategies/Strategies_Reducer_Integration';
import { STRATEGIES_SM_TO_INTEGRATION } from '../js/Strategies/Strategies_SM_To_Integration';
import { hangUpFromSip, streamFromSip } from '../redux/actions/A_sip_client_actions';
import { updateInfoWB } from '../redux/actions/A_other_actions';
import {
	newUnifiedInboxConversation,
	newUnifiedInboxMessage,
	showUnifiedMessagesWindow,
	chatTyping,
	chatAnswersTemplates,
	endConversationChat,
	endConversationClient,
	setMultimediaDispositions,
	chatTakeover,
	newUnifiedInboxExternalMessage,
	newUnifiedInboxExternalNewMessage,
	changeStateExternalMessage,
	aceptedChat,
	changeStateMessage,
	conversationTimeoutReached,
	endConversationsCampaignDeleted,
	newHistoricalConversation,
	errorOnHistoricalConversation,
	alertMessageErrorMMC,
	updatePermissions,
	updateConversationsPhoneChange
} from '../redux/actions/A_actions_UnifiedInbox';
import { messageTransferCall, manualCall, sendMessageNoAvailable, messageChangeState, actionResponseTransfer, actionPreviewRecord, messageToStateMachine } from '../redux/actions/A_messages_to_SM';
import { logout } from '../redux/actions/A_user_actions';
import { helperLanguage } from '../js/helpers/helperLanguage';
import { UtilityFactory } from 'global-common-utilities-js/global-common-utilities-js-bundle.js';
import { Logger } from '../js/helpers/Logger.js';
import { SOFTPHONE_CALLBACKS, SOFTPHONE_VALIDATING, SOFTPHONE_MAKECALL, SOFTPHONE_PARAMETERS, SOFTPHONE_HANGUP } from '../js/Strategies/Strategies_SoftPhone';
import 'react-resizable/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/General.css';
import { Singleton } from '../js/Singleton';
import AlertModal from './Alerts/AlertModal';
import AlertAudioFocusTab from './Alerts/AlertAudioFocusTab';
import AlertModalActions from '../redux/actions/A_Alert_Modal';
import { setCustomImages } from '../redux/actions/A_actions_from_white_label';
import { updateCount } from '../redux/actions/A_queue_count';
import { ProcessMessage } from './ProcessMessage.js';
import { toggleLocalLogging } from '../redux/actions/A_local_logging';
import { SMResponseHelper } from '../js/helpers/SMResponseHelper.js';
import {
	savePreviewRecord,
	updatePreviewRecord,
	cleanData,
	changeCampaignType,
	isSuccessfullChangeCamp,
	saveInitialTime,
	saveDataFromTransfer,
	setDialogTime,
	setDialingMode,
	setIsSendProcess,
	setTempPrevRecord,
	setPreviewSelectedCampaign,
	changePreviewRecordStatus,
	setInitialDialogTime,
	setCallId,
	setDialogTimeSimultaneousView,
	setSelectedRecord,
	setNDScheduled
} from '../redux/actions/A_preview';
import { dataTransferPreview, onAcceptedTransfer, showAlert, showPreviewData, setTransferInProgress, setUnnasignByXfer } from '../redux/actions/A_preview_transfer.js';
import AdminAlertModal from './Alerts/AdminAlertModal.jsx';
import { showAdminModal, hideAdminModal } from '../redux/actions/A_Admin_Alert_Modal';
import { DialogBox } from 'global-components-library';
import { setAllowChangeDialing, setAllowPlayRecordsOnCallHistory } from '../redux/actions/A_agent_permissions.js';
import { setMessageStatus } from '../redux/actions/A_manual_message.js';
import { assistedErrorTransfer, bindTransfer, resetAssistedErrorTransfer, resetTransfer, showDataTransferBySetting } from '../redux/actions/A_transfer.js';

const SERVER_IP = '192.168.1.34';

const INTEGRATION_IP = SERVER_IP;
let parameterMizu = {};
let parametersWebRTC = {};
let rabbitMqTest = null;
let networkMonitoringConfig = {};
let integrationConfig = {};
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLogged: false,
			consulting: 0,
			callType: 1,
			idChangeCount: -1,
			queueCount: 0,
			timeInQueue: 0,
			alert: null,
			newAlertCode: 0,
			newAlertMessage: null,
			dataCall: {},
			extraDataCall: {},
			loginError: 0,
			isInConference: false,
			loadedLanguaje: false,
			softPhoneLoaded: false,
			integrationAutorun: false,
			smReady: true,
			dialogShow: false,
			dialogContent: {}
		};
		this.handleUnload = this.handleUnload.bind(this);
		this.dateSendMessage = { date: new Date(), message: null };
		this.numerReconnect = 0;
		this.Engines = {};
		this.language = new Singleton();
		this.sharedData = new SingletonSharedData();
		this.language = new Singleton();
		this.smResponseHelper = new SMResponseHelper();
		this.smResponseHelper.setThat(this);
		this.rabbitConnected = false;
		this.telephonyTime = 0;
		let APIFact = new APIFactory();
		this.apiCont = APIFact.buildClient();
		this.callId = 0;
		let utilityFactory = new UtilityFactory();
		this.urlClient = utilityFactory.buildURLClient();

		let arrayPage = window.location.href.split('/');
		let pageIntegrationToken = null;

		if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
			let isSSL = SERVER_IP.indexOf('.nuxiba.com') >= 0;
			this.apiCont.PathWS = `http${isSSL ? 's' : ''}://${SERVER_IP}/`;
			this.sharedData.integrationServer = INTEGRATION_IP;
			pageIntegrationToken = this.apiCont.PathWS + 'AgentKolob';
		} else {
			this.apiCont.PathWS = window.location.origin + '/';
			this.sharedData.integrationServer = window.location.hostname;
			pageIntegrationToken = arrayPage.slice(0, arrayPage.length - 1).join('/');
		}
		this.sharedData.setSecureConnection(this.apiCont.PathWS.includes('https'));

		let helperFrame = document.createElement('iframe');

		helperFrame.src = pageIntegrationToken + '/IntegrationToken.html';
		helperFrame.id = 'helperFrame';
		helperFrame.style = 'display:none;';
		let body = document.getElementsByTagName('body')[0];

		body.appendChild(helperFrame);

		this.actionsCall = {
			[ACTION_CALL_ACD.HANGUP]: () => this.hangUp(),
			[ACTION_CALL_ACD.MUTE]: parameters => this.agentController.muteCall(parameters),
			[ACTION_CALL_ACD.HOLD]: (parameters,callOutId) => this.hold(callOutId),
			[ACTION_CALL_ACD.DTMF]: parameters => this.DTMF(parameters)
		};

		this.userActionsApp = {
			[USER_ACTIONS.LOGOUT]: () => {
				this.logOut();
			}
		};
	}

	checkSoftPhone() {
		var softphone = false;
		this.setState({
			loadedLanguaje: true,
			integrationAutorun: this.sharedData.getIntegrationAutorun()
		});
		if (this.urlClient.getQueryVariable(STR_SOFTPHONE)) {
			softphone = this.urlClient.getQueryVariable(STR_SOFTPHONE).toUpperCase();
		}
		if (!softphone || !SOFTPHONES_KEY[softphone]) {
			let defSoftphone = SOFTPHONES_DEFAULT[this.sharedData.getSoftPhone()];
			if (defSoftphone) {
				Logger.Info('[App][checkSoftPhone] Setting default softphone [' + defSoftphone + ']');
				this.urlClient.updateQueryStringParameter(STR_SOFTPHONE, defSoftphone);
			} else {
				Logger.Error('[App][checkSoftPhone] No valid softphone');
				this.setState({ softPhoneLoaded: true });
				this.setState({ loginError: 1044 });
				defSoftphone = SOFTPHONES_DEFAULT[5];
			}
		} else {
			Logger.Info('[App][checkSoftPhone] Setting softphone [' + softphone + ']');
			let AgentFact = new AgentControllerFactory();

			let softphoneKey = SOFTPHONES_KEY[softphone] ? SOFTPHONES_KEY[softphone] : SOFTPHONES_KEY.WEBRTC;

			this.sharedData.setSoftPhone(softphoneKey);
			try {
				Logger.Debug('rabbitMqTest ', rabbitMqTest);
				if (!rabbitMqTest) {
					rabbitMqTest = { isWebStomp: true };
				}
				this.agentController = AgentFact.buildClient(softphoneKey, rabbitMqTest.isWebStomp);
			} catch (e) {
				Logger.Error('AgentFact.buildClient', e);
			}
			this.loadAgentMethods();
			this.setState({ softPhoneLoaded: true });
		}
		console.log('Test sofphone', this.sharedData.getSoftPhone());
		var ip = this.manageIPAddress();
		this.setIP(ip);
	}
	setIP(ip) {
		if (this.sharedData.getSoftPhone() !== SOFTPHONES_KEY.MIZUJS) {
			this.sharedData.setIPAddress(ip);
			this.sharedData.setIPIntegration(ip);
		} else {
			this.sharedData.setIPIntegration(ip);
		}
	}

	manageIPAddress() {
		var ip = this.getIPAddress();
		return ip;
	}

	getIPAddress() {
		let myIP = this.sharedData.getIPfromAPI();
		return myIP;
	}

	loadAgentMethods() {
		var _this = this;
		this.agentController.AgentObject.onConnected = () => {
			Logger.Trace('[App][loadAgentMethods] Connected to Rabbit!');
			_this.rabbitConnected = true;
			_this.agentController.subscribeTopics(_this.sharedData.getUserData().Login + '|');
			_this.sendToRabbit(SM_QUEUE_SERVER, messageLogin(_this.agentController.getTimeStamp()));
			_this.getChatLog();
		};

		this.agentController.AgentObject.onDisconnected = () => {
			this.messageDisconnect();
			this.agentController.disconnectBroker();
			this.rabbitConnected = false;
		};

		this.agentController.AgentObject.onMessage = mensaje => {
			Logger.Debug('[App][loadAgentMethods] Message received => ' + mensaje);
			try {
				_this.processMessage(JSON.parse(mensaje));
			} catch (err) {
				Logger.Warn('[App][loadAgentMethods] Message not process => ' + mensaje, err);
			}
		};

		this.agentController.AgentObject.onReconnected = () => {
			Logger.Debug('[App][loadAgentMethods] Reconnected');
			_this.setState({ smReady: false });
			_this.sendToRabbit(SM_QUEUE_SERVER, Reconnected());
			setTimeout(() => {
				if (!_this.state.smReady) {
					Logger.Debug("[App][loadAgentMethods] Didn't revice reconnected package ");
					this.messageDisconnect();
				}
			}, 7000);
		};
		//METODOS SIP SOBREESCRITOS
		SOFTPHONE_CALLBACKS[this.sharedData.getSoftPhone()](this);
	}
	messageDisconnect() {
		var _this = this;
		_this.numerReconnect = 0;
		if (_this.timerKeepAlive) {
			clearInterval(_this.timerKeepAlive);
			_this.timerKeepAlive = null;
		}
		Logger.Info('ONDISCONNECTED ');
		_this.rabbitConnected = false;
		this.props.showAlertModal({
			type: 'ModalError',
			title: 'CenterWare Kolob',
			message: this.language.getText('error-1'),
			button: this.language.getText('GUITelephonyValidatorreconnect'),
			secondButtonFtn: () => {},
			buttonFun: () => {
				_this.logOut();
			}
		});
	}

	logOut() {
		this.numerReconnect = 0;
		if ((this.sharedData.getCurrentState() === 'Wrapup' || this.sharedData.getCurrentState() === 'Dialog') && !this.sharedData.getIsRated()) {
			Logger.Trace('The call:' + this.callId + ' was not rated. Reason: Logout, LastState:' + this.sharedData.getCurrentState());
		}
		if (this.state.isLogged) {
			Logger.Trace('[App][logOut] OnLogout');
			this.sendToRabbit(SM_QUEUE_SERVER, RequestedLogout());
			this.setState({
				isLogged: false,
				idChangeCount: -1,
				queueCount: 0,
				timeInQueue: 0
			});
			clearInterval(this.timerKeepAlive);
			this.props.changeState(USER_STATE.LOGED_OUT);
			this.agentController.disconnectBroker();
			this.rabbitConnected = false;
			this.sharedData.setCurrentState('logout');
			const integrationMessage = { client: 'galatea', action: 'onLogOut' };
			SingletonWebSocket.send(integrationMessage);
			this.sharedData.clearChatList();
			setTimeout(() => {
				location.reload();
			}, 1500);
		}
	}

	async componentDidMount() {
		window.addEventListener('beforeunload', this.handleUnload);
		const publicLocation = process.env.NODE_ENV === 'development' ? '/' : window.location.pathname;
		const whiteLabelConfig = await fetch(`${publicLocation}manifest.json?timeSPam=${Math.random()}`).then(response => response.json());
		parameterMizu = whiteLabelConfig.mizuJs;
		rabbitMqTest = whiteLabelConfig.rabbit;
		parametersWebRTC = whiteLabelConfig.webRTC;
		networkMonitoringConfig = whiteLabelConfig.networkMonitoring;
		integrationConfig = whiteLabelConfig.integration;
		if (integrationConfig && integrationConfig.hide) {
			let helperFrame2 = document.createElement('iframe');
			helperFrame2.src = this.apiCont.PathWS + (integrationConfig.path ? integrationConfig.path : 'AgentKolob') + '/Integration/';
			helperFrame2.id = 'helperFrame2';
			helperFrame2.name = 'helperFrame2';
			helperFrame2.style = 'display:none;';
			let body = document.getElementsByTagName('body')[0];
			body.appendChild(helperFrame2);
		}
		if (integrationConfig && integrationConfig.sendDataOncallout) {
			this.sharedData.setSendDataOncallout(integrationConfig.sendDataOncallout);
		}
		if (whiteLabelConfig.whiteLabelEnabled === true) {
			if (whiteLabelConfig.imageFormat === 'svg') {
				const login = await fetch(`${publicLocation}logos/login.svg`).then(response => response.text());
				const header = await fetch(`${publicLocation}logos/header.svg`).then(response => response.text());
				const about = await fetch(`${publicLocation}logos/about.svg`).then(response => response.text());
				await this.props.setCustomImages(whiteLabelConfig.whiteLabelEnabled, 'svg', login, header, about);
			} else {
				const login = await fetch(`${publicLocation}logos/login.${whiteLabelConfig.imageFormat}`)
					.then(response => response.blob())
					.then(img => URL.createObjectURL(img));
				const header = await fetch(`${publicLocation}logos/header.${whiteLabelConfig.imageFormat}`)
					.then(response => response.blob())
					.then(img => URL.createObjectURL(img));
				const about = await fetch(`${publicLocation}logos/about.${whiteLabelConfig.imageFormat}`)
					.then(response => response.blob())
					.then(img => URL.createObjectURL(img));
				await this.props.setCustomImages(whiteLabelConfig.whiteLabelEnabled, 'image', login, header, about);
			}
		}
		const ts = new Date();
		const logKey = `LOG-${ts.getDate()}-${ts.getMonth() + 1}-${ts.getFullYear()}`;
		ts.setDate(ts.getDate() - 1);
		const lastLogKey = `LOG-${ts.getDate()}-${ts.getMonth() + 1}-${ts.getFullYear()}`;
		window.localStorage.removeItem(lastLogKey);
		Logger.EnableLocalLog(whiteLabelConfig.enableLocalLog, whiteLabelConfig.cleanLocalLogsMin);
		if (whiteLabelConfig.enableLocalLog) {
			this.props.toggleLocalLogging(true);
			const prevEntries = window.localStorage.getItem(logKey);
			// window.localStorage.setItem(logKey, 'LOG START')
			prevEntries ? window.localStorage.setItem(logKey, `${prevEntries};LOG START`) : window.localStorage.setItem(logKey, 'LOG START');
		} else {
			window.localStorage.removeItem(logKey);
		}

		var _this = this;
		let langHelper = new helperLanguage();
		langHelper.setLanguage('', () => {
			_this.checkSoftPhone();
		});
	}
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.handleUnload);
	}

	handleUnload(e) {
		Logger.Trace('handleUnload Refresh', e);
		this.setState({
			consulting: this.state.consulting - 1
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			consulting: nextProps.consultingCounter.consulting
		});

		if (this.userActionsApp[nextProps.userActions.actionType]) {
			this.userActionsApp[nextProps.userActions.actionType]();
		}
		nextProps.messagesToSM.message !== this.props.messagesToSM.message && this.sendToRabbit(SM_QUEUE_SERVER, nextProps.messagesToSM.message);
		// nextProps.messagesToSM.message = "";
		if (this.actionsCall[nextProps.callActionsACD.callAction]) {
			this.actionsCall[nextProps.callActionsACD.callAction](nextProps.callActionsACD.parameters,nextProps.callActionsACD.callOutId);
			nextProps.callActionsACD.callAction = null;
		}
		if (nextProps.volumeControl && nextProps.volumeControl.changingVolume) {
			this.volume(nextProps.volumeControl.speakerVolume, nextProps.volumeControl.microphoneVolume);
		}

		if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
			if (nextProps.messagesIntegrations.dataMessageIntegration) {
				if (STRATEGIES_REDUCER_INTEGRATION[nextProps.messagesIntegrations.dataMessageIntegration.action]) {
					STRATEGIES_REDUCER_INTEGRATION[nextProps.messagesIntegrations.dataMessageIntegration.action](this, nextProps.messagesIntegrations.dataMessageIntegration);
				}
			}
		}
	}

	connectCall(message, userID) {
		SOFTPHONE_MAKECALL[this.sharedData.getSoftPhone()](this, message, userID);
	}
	parametersRabbit() {
		Logger.Trace('[App][parametersRabbit] Reading setting 199 for MessageQueue Configuration');
		let rabbitParametters = this.sharedData.getGeneralPermissions()[199];
		Logger.Debug('[App][parametersRabbit] MessageQueue configuration: ', rabbitParametters);
		var settingRabbit = rabbitParametters.split('|');
		let secureConnection = this.sharedData.getSecureConnection();
		let port = !secureConnection ? '15674' : settingRabbit[2];

		if (rabbitMqTest && !rabbitMqTest.isWebStomp) {
			port = !secureConnection ? rabbitMqTest.port : rabbitMqTest.portSSL;
			Logger.Debug('Port MqTT ', port);
		}

		this.agentController.AgentObject.mq_port = port;
		this.agentController.AgentObject.mq_vhost = settingRabbit[3];
		this.agentController.AgentObject.mq_username = settingRabbit[4];
		this.agentController.AgentObject.mq_password = settingRabbit[5];
		this.agentController.AgentObject.mq_consumer = this.sharedData.getUserData().Login;
		this.agentController.AgentObject.mq_expiration = settingRabbit[6];
		this.agentController.AgentObject.mq_secureConnection = secureConnection;
		this.agentController.AgentObject.heartbeat = {
			outgoing: 20000,
			incoming: 20000
		};

		if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
			this.agentController.AgentObject.mq_server = SERVER_IP;
		} else {
			this.agentController.AgentObject.mq_server = window.location.hostname;
		}
	}
	setParameters() {
		this.parametersRabbit();
		SOFTPHONE_PARAMETERS[this.sharedData.getSoftPhone()](this, parameterMizu);
	}
	parametersEngine() {
		Logger.Trace('[App][parametersEngine] Reading setting 143 for Engine Configuration');
		let parameterEngine = this.sharedData.getGeneralPermissions()[143];
		Logger.Trace('[App][parametersEngine] Engine configuration: ', parameterEngine);
		var enginesPosition = parameterEngine.split(',');
		for (var i = 0; i < enginesPosition.length; i++) {
			var position = enginesPosition[i].split('|');
			this.Engines[position[0]] = position[1];
		}
	}
	setIpEngine(engineId, ipKamailio) {
		Logger.Trace('[App][setIpEngine] Reading setting 131 for Mizu Configuration');
		let setting131 = this.sharedData.getGeneralPermissions()[131];
		Logger.Trace('[App][setIpEngine] Mizu configuration: ', setting131);
		var datoPBX = setting131.split('|');
		let CNF = 'PBX' + engineId + '@' + datoPBX[7];
		Logger.Trace('Destination: ' + CNF);
		CNF = this.apiCont.cypher.md5Encryption(CNF);
		Logger.Trace('Destination: ' + CNF);
		this.agentController.AgentObject.SIP_CNF_XD = CNF;
		this.agentController.AgentObject.SIP_KAMAILIO = '@' + ipKamailio + ':5061';
		if (parametersWebRTC) {
			Logger.Trace('[Strategies_SoftPhone][SOFTPHONE_PARAMETERS] Parameters to WebRTC manifest.json => ', parametersWebRTC);
			if (parametersWebRTC.SIP_iceCheckingTimeout) {
				this.agentController.AgentObject.SIP_iceCheckingTimeout = parametersWebRTC.SIP_iceCheckingTimeout;
			}
		}
		this.agentController.UpdateParametersSIP();
	}
	tryMessageToIntegration(message) {
		if (STRATEGIES_SM_TO_INTEGRATION[message.action]) {
			STRATEGIES_SM_TO_INTEGRATION[message.action](this, message);
		}
	}
	stateMachineDown() {
		this.setState({
			consulting: this.state.consulting - 1,
			loginError: 1029
		});
		const message = {
			code: 1029,
			message: this.language.getText('error-' + 1029)
		};
		const integrationMessage = {
			client: 'galatea',
			data: message,
			action: 'remoteLoginError'
		};
		SingletonWebSocket.send(integrationMessage);
	}
	callStateAction(message) {
		if (STRATEGIES_STATES[message.currentState]) {
			if (message.currentState !== 'Ready') {
				this.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
			}
			if (this.sharedData.getCurrentState() === 'Wrapup' && !this.sharedData.getIsRated()) {
				Logger.Trace('The call:' + this.callId + ' was not rated CurrentState:' + message.currentState);
			}
			STRATEGIES_STATES[message.currentState](message, this, document.getElementById('audio-call'));
			if (message.currentState === 'ERROR') {
				setTimeout(() => {
					location.reload();
				}, 2000);
			} else if (message.currentState !== 'ERROR' && message.currentState !== 'ALERT') {
				let integrationMessage = {
					client: 'galatea',
					data: message,
					action: 'agentStatusChange'
				};
				SingletonWebSocket.send(integrationMessage);
				this.sharedData.setCurrentState(message.currentState);
			}
		} else {
			Logger.Warn('[App][callStateAction] State Not implement ', message.currentState);
		}
	}
	processMessage(message) {
		if (this.state.alert) {
			this.setState({ alert: null });
		}
		this.smResponseHelper.clearTimer(message);
		ProcessMessage(message, this);
	}

	sendToRabbit(topic, message) {
		if (message) {
			this.smResponseHelper.setTimer(message);
			delete message.ExpectsReponse;
			let obj = message;
			if (typeof message === 'string') {
				obj = JSON.parse(message);
			}
			obj.timeSpam = this.agentController.getTimeStamp();
			message = JSON.stringify(obj);
			Logger.Debug('[App][sendToRabbit] Sending Message =>' + message + ' TOPIC => ' + topic);
			this.agentController.sendMessage(topic, message);
			this.dateSendMessage = new Date();
			this.props.resetMessageToSM();
		}
	}
	getChatLog() {
		let objectResponse = this.apiCont.getObjectResponse();
		var _this = this;
		this.apiCont.getChatLog(this.sharedData.getParameters().UserID, objectResponse);
		objectResponse.onError = function () {};
		objectResponse.onSuccess = function (objResponse) {
			for (var admin in objResponse) {
				var messages = objResponse[admin];
				for (var messageID in messages) {
					_this.sharedData.setObjectChat(messages[messageID], admin);
				}
			}
		};
	}
	makeCall(callId) {
		var _this = this;
		setTimeout(() => {
			_this.agentController.makeCall(callId);
		}, 200);
	}
	hangUp() {
		this.sendToRabbit(SM_QUEUE_SERVER, messageHangUp(HANG_UP_SUBACTIONS.CALL,0));
	}

	hold(callOutId) {
		this.sendToRabbit(SM_QUEUE_SERVER, messageApiRequest(API_ENDPOINTS.HOLD, '',false,callOutId));
	}
	volume(speaker, microphone) {
		Logger.Info('[App][volume] set volume speaker:' + speaker + ' microphone:' + microphone + '');
		this.agentController.volumeSpeaker(speaker);
		this.agentController.volumeMicrophone(microphone);
		Logger.Info('[App][volume] get volume speaker:' + this.agentController.volumeSpeakerGet() + ' microphone:' + this.agentController.volumeMicrophoneGet() + '');
	}
	DTMF(digit) {
		if (digit.length === 1) {
			setTimeout(() => {
				this.agentController.dtmf(digit);
			}, 20);
		} else {
			for (let i in digit) {
				setTimeout(() => {
					this.agentController.dtmf(digit[i]);
				}, 50 * (i + 1));
			}
		}
	}
	deleteAlert() {
		this.setState({ alert: null });
	}
	componentDidUpdate() {
		if (this.state.alert) {
			this.deleteAlert();
		}
		if (this.state.newAlertCode !== 0) {
			this.setState({ newAlertCode: 0 });
		}
	}
	actionsValitatingTelephony() {
		SOFTPHONE_VALIDATING[this.sharedData.getSoftPhone()](this);
	}
	checkOtherState() {
		if (this.sharedData.getLogged()) {
			this.props.changeState(USER_STATE.OTHER);
		} else {
			SOFTPHONE_HANGUP[this.sharedData.getSoftPhone()](this);
		}
	}
	loginWebAgent() {
		if (window['NuxibaLogger']['_SERVER'] !== window.location.origin && process.env.NODE_ENV !== 'development') {
			window['NuxibaLogger']['_SERVER'] = window.location.origin;
		}
		if (!this.rabbitConnected) {
			this.setState({ consulting: this.state.consulting + 1 });
			this.setParameters();
			this.agentController.connectToRabbit();
		} else {
			this.setState({ consulting: this.state.consulting + 1 });
			this.sendToRabbit(SM_QUEUE_SERVER, messageLogin(this.agentController.getTimeStamp()));
		}
	}
	showDialogBox(data) {
		this.setState({
			dialogContent: { ...data },
			dialogShow: !this.state.dialogShow
		});
	}
	render() {
		return (
			<div className='AgentContainer'>
				<canvas className='canvas-overlay'></canvas>
				{this.state.isLogged ? (
					<div>
						<Header callType={this.state.callType} idChangeCount={this.state.idChangeCount} queueCount={this.state.queueCount} timeInQueue={this.state.timeInQueue} />

						<WorkSpace
							alert={this.state.alert}
							newAlertCode={this.state.newAlertCode}
							newAlertMessage={this.state.newAlertMessage}
							dataCall={this.state.dataCall}
							extraDataCall={this.state.extraDataCall}
							networkMonitoring={networkMonitoringConfig}
						/>
						<AlertModal />
						<AlertAudioFocusTab />
						<AdminAlertModal />
						<DialogBox show={this.state.dialogShow} toggle={() => this.setState({ dialogShow: !this.state.dialogShow })} {...this.state.dialogContent} />
					</div>
				) : (
					<Login softPhoneLoaded={this.state.softPhoneLoaded} languageLoaded={this.state.loadedLanguaje} loginError={this.state.loginError} onLogin={() => this.loginWebAgent()} />
				)}
				<Footer isLogged={this.state.isLogged} integrationAutorun={this.state.integrationAutorun} integrationIconActived={this.sharedData.getintegrationIconActived()} />
				{this.state.consulting > 0 && <Consulting />}
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	const { showAlertModal } = AlertModalActions.creators;
	const { hideAlertModal } = AlertModalActions.creators;
	return {
		messageChangeState: () => {
			dispatch(messageChangeState());
		},
		sendMessageNoAvailable: (userName, userID, notReadyID, timeInPreview) => {
			dispatch(sendMessageNoAvailable(userName, userID, notReadyID, timeInPreview));
		},
		logout: () => {
			dispatch(logout());
		},
		changeState: newState => {
			dispatch(changeState(newState));
		},
		noAvailableData: (frameNA, timeNA, supervisorPassNA, descriptionNA) => {
			dispatch(noAvailableData(frameNA, timeNA, supervisorPassNA, descriptionNA));
		},
		validatingState: (stateV, timeV) => {
			dispatch(validatingState(stateV, timeV));
		},
		messageFromSupervisor: (message, supervisor) => {
			dispatch(messageFromSupervisor(message, supervisor));
		},
		hangUpFromSip: () => {
			dispatch(hangUpFromSip());
		},
		streamFromSip: data => {
			dispatch(streamFromSip(data));
		},
		agentUnavailableOnTransfer: message => {
			dispatch(agentUnavailableOnTransfer(message));
		},
		newAssistedTransferState: message => {
			dispatch(newAssistedTransferState(message));
		},
		updateInfoWB: workItem => {
			dispatch(updateInfoWB(workItem));
		},
		messageTransferCall: data => {
			dispatch(messageTransferCall(data));
		},
		showAlertModal: payload => {
			dispatch(showAlertModal(payload));
		},
		hideAlertModal: payload => {
			dispatch(hideAlertModal(payload));
		},
		newUnifiedInboxConversation: message => {
			dispatch(newUnifiedInboxConversation(message));
		},
		newUnifiedInboxMessage: message => {
			dispatch(newUnifiedInboxMessage(message));
		},
		newUnifiedInboxExternalMessage: message => {
			dispatch(newUnifiedInboxExternalMessage(message));
		},
		newUnifiedInboxExternalNewMessage: message => {
			dispatch(newUnifiedInboxExternalNewMessage(message));
		},
		changeStateMessage: message => {
			dispatch(changeStateMessage(message));
		},
		changeStateExternalMessage: message => {
			dispatch(changeStateExternalMessage(message));
		},
		showUnifiedMessagesWindow: show => {
			dispatch(showUnifiedMessagesWindow(show));
		},
		chatTyping: message => {
			dispatch(chatTyping(message));
		},
		chatTakeover: message => {
			dispatch(chatTakeover(message));
		},
		chatAnswersTemplates: message => {
			dispatch(chatAnswersTemplates(message));
		},
		endConversationChat: message => {
			dispatch(endConversationChat(message));
		},
		aceptedChat: message => {
			dispatch(aceptedChat(message));
		},
		endConversationClient: (message, clientTermination) => {
			dispatch(endConversationClient(message, clientTermination));
		},
		setCustomImages: (whiteLabelEnabled, imageFormat, login, header, about) => dispatch(setCustomImages(whiteLabelEnabled, imageFormat, login, header, about)),
		setMultimediaDispositions: message => {
			dispatch(setMultimediaDispositions(message));
		},
		updateCount: (itemQueue, countQueue, timeInQueue) => {
			dispatch(updateCount(itemQueue, countQueue, timeInQueue));
		},
		toggleLocalLogging: enableLocalLog => {
			dispatch(toggleLocalLogging(enableLocalLog));
		},
		removeWindow: iDdragComponent => {
			dispatch(removeWindow(iDdragComponent));
		},
		manualCall: data => {
			dispatch(manualCall(data));
		},
		conversationTimeoutReached: data => {
			dispatch(conversationTimeoutReached(data));
		},
		endConversationsCampaignDeleted: data => {
			dispatch(endConversationsCampaignDeleted(data));
		},
		newHistoricalConversation: data => {
			dispatch(newHistoricalConversation(data));
		},
		errorOnHistoricalConversation: data => {
			dispatch(errorOnHistoricalConversation(data));
		},
		dataTransferPreview: (previewAction, phoneList, acdList, agentList) => {
			dispatch(dataTransferPreview(previewAction, phoneList, acdList, agentList));
		},
		actionResponseTransfer: (agent, response) => {
			dispatch(actionResponseTransfer(agent, response));
		},
		actionPreviewRecord: data => {
			dispatch(actionPreviewRecord(data));
		},
		insertWindow: (dragWindow, closeComponentIfOpen) => {
			dispatch(insertWindow(dragWindow, closeComponentIfOpen));
		},
		updatePermissions: (permissionName, permissionValue) => {
			dispatch(updatePermissions(permissionName, permissionValue));
		},
		showAdminModal: payload => {
			dispatch(showAdminModal(payload));
		},
		hideAdminModal: () => {
			dispatch(hideAdminModal());
		},
		updateConversationsPhoneChange: data => {
			dispatch(updateConversationsPhoneChange(data));
		},
		savePreviewRecord: data => {
			dispatch(savePreviewRecord(data));
		},
		onAcceptedTransfer: value => {
			dispatch(onAcceptedTransfer(value));
		},
		updatePreviewRecord: data => {
			dispatch(updatePreviewRecord(data));
		},
		cleanData: () => {
			dispatch(cleanData());
		},
		changeCampaignType: flag => {
			dispatch(changeCampaignType(flag));
		},
		isSuccessfullChangeCamp: flag => {
			dispatch(isSuccessfullChangeCamp(flag));
		},
		saveInitialTime: () => {
			dispatch(saveInitialTime());
		},
		alertMessageErrorMMC: message => {
			dispatch(alertMessageErrorMMC(message));
		},
		showAlert: () => {
			dispatch(showAlert());
		},
		showPreviewData: payload => {
			dispatch(showPreviewData(payload));
		},
		saveDataFromTransfer: message => {
			dispatch(saveDataFromTransfer(message));
		},
		setDialogTime: message => {
			dispatch(setDialogTime(message));
		},
		setDialingMode: message => {
			dispatch(setDialingMode(message));
		},
		setAllowPlayRecordsOnCallHistory: allowPlayRecordsOnCallHistory => {
			dispatch(setAllowPlayRecordsOnCallHistory(allowPlayRecordsOnCallHistory));
		},
		setIsSendProcess: flag => {
			dispatch(setIsSendProcess(flag));
		},
		setTempPrevRecord: data => {
			dispatch(setTempPrevRecord(data));
		},
		onSetMessageStatus: (messageStatus, phone) => {
			dispatch(setMessageStatus(messageStatus, phone));
		},
		setAllowChangeDialingMode: mode => {
			dispatch(setAllowChangeDialing(mode));
		},
		setPreviewSelectedCampaign: data => {
			dispatch(setPreviewSelectedCampaign(data));
		},
		changePreviewRecordStatus : data => {
			dispatch(changePreviewRecordStatus(data));
		},
		setInitialDialogTime: data => {
			dispatch(setInitialDialogTime(data));
		},
		setCallId : data=>{
			dispatch(setCallId(data));
		},
		setDialogTimeSimultaneousView: data =>{
			dispatch(setDialogTimeSimultaneousView(data))
		},
		bindTransfer: data => {
			dispatch(bindTransfer(data));
		},
		resetTransfer:() => {
			dispatch(resetTransfer());
		},
		assistedErrorTransfer: (data)=>{
			dispatch(assistedErrorTransfer(data));
		},
		resetAssistedErrorTransfer: ()=>{
			dispatch(resetAssistedErrorTransfer());
		},
		setSelectedRecord: (callOutId) => {
			dispatch(setSelectedRecord(callOutId))
		},
		setNDScheduled: () => {
			dispatch(setNDScheduled());
		},
		setTransferInProgress: (flag) => {
			dispatch(setTransferInProgress(flag))
		},
		setUnnasignByXfer: (flag) => {
			dispatch(setUnnasignByXfer(flag))
		},
        resetMessageToSM: () => {
            dispatch(messageToStateMachine(null));
		},
		showDataTransferBySetting : (flag) => {
			dispatch(showDataTransferBySetting(flag))
		}
	};
}

function mapStateToProps(state) {
	return {
		consultingCounter: state.consultingCounter,
		messagesToSM: state.messagesToSM,
		userActions: state.userActions,
		callActionsACD: state.callActionsACD,
		volumeControl: state.volumeControl,
		messagesIntegrations: state.messagesIntegrations,
		selectedConversarionID: state.unifiedInboxState.selectedID,
		preview: state.preview,
		userState: state.userState,
		transferReducer: state.transferReducer,
	};
}

export default App = connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.jsx